import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UserQualification } from '@wilson/interfaces';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'wilson-qualification-name-date-renderer',
  styleUrls: ['./renderers.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div>
      <div class="lh-m">
        {{
          cellValues?.date && !cellValues?.date?.includes('2099')
            ? ($safeNavigationMigration(cellValues?.date) | date: 'dd.MM.yyyy')
            : ('page.qualifications.infinitely_valid' | translate)
        }}
      </div>
    </div>
  `,
  standalone: false,
})
export class QualificationNameDateRendererComponent
  implements AgRendererComponent
{
  public cellValues: {
    date?: string | undefined;
  } | null = null;

  agInit(params: ICellRendererParams): void {
    this.cellValues = this.getValueToDisplay(params);
  }

  refresh(params: ICellRendererParams) {
    this.cellValues = this.getValueToDisplay(params);
    return true;
  }

  getValueToDisplay(params: ICellRendererParams): {
    date?: string;
  } {
    const userQualification = params.data as UserQualification;

    return {
      date: userQualification.updatedAt,
    };
  }
}
